// Author Lin
// Date 2021-12-04 15:59:27

class MintalMesPrdSmeltingMaterialConsumption {
        constructor({
                id = null,
                recordTime = '',
                locationId = '',
                locationName = '',
                furnaceId = '',
                furnaceName = '',
                pelletConsumption = '',
                pelletWater = '',
                pelletDryBasis = '',
                cokeName1 = '',
                cokeConsumption1 = '',
                cokeWater1 = '',
                cokeDryBasis1 = '',
                cokeName2 = '',
                cokeConsumption2 = '',
                cokeWater2 = '',
                cokeDryBasis2 = '',
                cokeName3 = '',
                cokeConsumption3 = '',
                cokeWater3 = '',
                cokeDryBasis3 = '',
                cokeName4 = '',
                cokeConsumption4 = '',
                cokeWater4 = '',
                cokeDryBasis4 = '',
                cokeName5 = '',
                cokeConsumption5 = '',
                cokeWater5 = '',
                cokeDryBasis5 = '',
                cokeTotalConsumption = '',
                cokeTotalDry = '',
                silicaConsumption = '',
                dolomiteConsumption = '',
                serpentineConsumption = '',
                heavySlag = '',
                recorderId = '',
                reviewerId = '',
                remark = ''}
        = {}) {
            this.id = id;
            this.recordTime = recordTime;
            this.locationId = locationId;
            this.locationName = locationName;
            this.furnaceId = furnaceId;
            this.furnaceName = furnaceName;
            this.pelletConsumption = pelletConsumption;
            this.pelletWater = pelletWater;
            this.pelletDryBasis = pelletDryBasis;
            this.cokeName1 = cokeName1;
            this.cokeConsumption1 = cokeConsumption1;
            this.cokeWater1 = cokeWater1;
            this.cokeDryBasis1 = cokeDryBasis1;
            this.cokeName2 = cokeName2;
            this.cokeConsumption2 = cokeConsumption2;
            this.cokeWater2 = cokeWater2;
            this.cokeDryBasis2 = cokeDryBasis2;
            this.cokeName3 = cokeName3;
            this.cokeConsumption3 = cokeConsumption3;
            this.cokeWater3 = cokeWater3;
            this.cokeDryBasis3 = cokeDryBasis3;
            this.cokeName4 = cokeName4;
            this.cokeConsumption4 = cokeConsumption4;
            this.cokeWater4 = cokeWater4;
            this.cokeDryBasis4 = cokeDryBasis4;
            this.cokeName5 = cokeName5;
            this.cokeConsumption5 = cokeConsumption5;
            this.cokeWater5 = cokeWater5;
            this.cokeDryBasis5 = cokeDryBasis5;
            this.cokeTotalConsumption = cokeTotalConsumption;
            this.cokeTotalDry = cokeTotalDry;
            this.silicaConsumption = silicaConsumption;
            this.dolomiteConsumption = dolomiteConsumption;
            this.serpentineConsumption = serpentineConsumption;
            this.heavySlag = heavySlag;
            this.recorderId = recorderId;
            this.reviewerId = reviewerId;
            this.remark = remark;
        }
        }
        
        function newEntity() {
        return new MintalMesPrdSmeltingMaterialConsumption();
        }
        
            function gridFields() {
            return Object.freeze([
                {
                key: 'id',
                label: 'label.mintal.prd.mintalMesPrdSmeltingMaterialConsumption.grid.id',
                sortable: true,
                    isDetail: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'recordTime',
                label: 'label.mintal.prd.mintalMesPrdSmeltingMaterialConsumption.grid.recordTime',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'locationName',
                label: 'label.mintal.prd.mintalMesPrdSmeltingMaterialConsumption.grid.locationName',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'furnaceName',
                label: 'label.mintal.prd.mintalMesPrdSmeltingMaterialConsumption.grid.furnaceName',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'pelletConsumption',
                label: 'label.mintal.prd.mintalMesPrdSmeltingMaterialConsumption.grid.pelletConsumption',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'pelletWater',
                label: 'label.mintal.prd.mintalMesPrdSmeltingMaterialConsumption.grid.pelletWater',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'pelletDryBasis',
                label: 'label.mintal.prd.mintalMesPrdSmeltingMaterialConsumption.grid.pelletDryBasis',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'cokeName1',
                label: 'label.mintal.prd.mintalMesPrdSmeltingMaterialConsumption.grid.cokeName1',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'cokeConsumption1',
                label: 'label.mintal.prd.mintalMesPrdSmeltingMaterialConsumption.grid.cokeConsumption1',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'cokeWater1',
                label: 'label.mintal.prd.mintalMesPrdSmeltingMaterialConsumption.grid.cokeWater1',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'cokeDryBasis1',
                label: 'label.mintal.prd.mintalMesPrdSmeltingMaterialConsumption.grid.cokeDryBasis1',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'cokeName2',
                label: 'label.mintal.prd.mintalMesPrdSmeltingMaterialConsumption.grid.cokeName2',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'cokeConsumption2',
                label: 'label.mintal.prd.mintalMesPrdSmeltingMaterialConsumption.grid.cokeConsumption2',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'cokeWater2',
                label: 'label.mintal.prd.mintalMesPrdSmeltingMaterialConsumption.grid.cokeWater2',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'cokeDryBasis2',
                label: 'label.mintal.prd.mintalMesPrdSmeltingMaterialConsumption.grid.cokeDryBasis2',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'cokeName3',
                label: 'label.mintal.prd.mintalMesPrdSmeltingMaterialConsumption.grid.cokeName3',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'cokeConsumption3',
                label: 'label.mintal.prd.mintalMesPrdSmeltingMaterialConsumption.grid.cokeConsumption3',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'cokeWater3',
                label: 'label.mintal.prd.mintalMesPrdSmeltingMaterialConsumption.grid.cokeWater3',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'cokeDryBasis3',
                label: 'label.mintal.prd.mintalMesPrdSmeltingMaterialConsumption.grid.cokeDryBasis3',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'cokeName4',
                label: 'label.mintal.prd.mintalMesPrdSmeltingMaterialConsumption.grid.cokeName4',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'cokeConsumption4',
                label: 'label.mintal.prd.mintalMesPrdSmeltingMaterialConsumption.grid.cokeConsumption4',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'cokeWater4',
                label: 'label.mintal.prd.mintalMesPrdSmeltingMaterialConsumption.grid.cokeWater4',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'cokeDryBasis4',
                label: 'label.mintal.prd.mintalMesPrdSmeltingMaterialConsumption.grid.cokeDryBasis4',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'cokeName5',
                label: 'label.mintal.prd.mintalMesPrdSmeltingMaterialConsumption.grid.cokeName5',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'cokeConsumption5',
                label: 'label.mintal.prd.mintalMesPrdSmeltingMaterialConsumption.grid.cokeConsumption5',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'cokeWater5',
                label: 'label.mintal.prd.mintalMesPrdSmeltingMaterialConsumption.grid.cokeWater5',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'cokeDryBasis5',
                label: 'label.mintal.prd.mintalMesPrdSmeltingMaterialConsumption.grid.cokeDryBasis5',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'cokeTotalConsumption',
                label: 'label.mintal.prd.mintalMesPrdSmeltingMaterialConsumption.grid.cokeTotalConsumption',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'cokeTotalDry',
                label: 'label.mintal.prd.mintalMesPrdSmeltingMaterialConsumption.grid.cokeTotalDry',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'silicaConsumption',
                label: 'label.mintal.prd.mintalMesPrdSmeltingMaterialConsumption.grid.silicaConsumption',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'dolomiteConsumption',
                label: 'label.mintal.prd.mintalMesPrdSmeltingMaterialConsumption.grid.dolomiteConsumption',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'serpentineConsumption',
                label: 'label.mintal.prd.mintalMesPrdSmeltingMaterialConsumption.grid.serpentineConsumption',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'heavySlag',
                label: 'label.mintal.prd.mintalMesPrdSmeltingMaterialConsumption.grid.heavySlag',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'recorderId',
                label: 'label.mintal.prd.mintalMesPrdSmeltingMaterialConsumption.grid.recorderId',
                sortable: true,
                    isDetail: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'recorder',
                label: 'label.mintal.prd.mintalMesPrdSmeltingMaterialConsumption.grid.recorder',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'reviewerId',
                label: 'label.mintal.prd.mintalMesPrdSmeltingMaterialConsumption.grid.reviewerId',
                sortable: true,
                    isDetail: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'reviewer',
                label: 'label.mintal.prd.mintalMesPrdSmeltingMaterialConsumption.grid.reviewer',
                sortable: true,
                    isDetail: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'remark',
                label: 'label.mintal.prd.mintalMesPrdSmeltingMaterialConsumption.grid.remark',
                sortable: true,
                    isDetail: true,
                form: {
                type: 'textarea'
                }
                }
            ])}
        
        const filter = {
            idFilter : '',
            idListFilter : [],
            recordTimeRteFilter : '',
            recordTimeLteFilter : '',
            locationIdFilter : '',
            locationNameFilter : '',
            furnaceIdFilter : '',
            furnaceNameFilter : '',
            pelletConsumptionFilter : '',
            pelletWaterFilter : '',
            pelletDryBasisFilter : '',
            cokeName1Filter : '',
            cokeConsumption1Filter : '',
            cokeWater1Filter : '',
            cokeDryBasis1Filter : '',
            cokeName2Filter : '',
            cokeConsumption2Filter : '',
            cokeWater2Filter : '',
            cokeDryBasis2Filter : '',
            cokeName3Filter : '',
            cokeConsumption3Filter : '',
            cokeWater3Filter : '',
            cokeDryBasis3Filter : '',
            cokeName4Filter : '',
            cokeConsumption4Filter : '',
            cokeWater4Filter : '',
            cokeDryBasis4Filter : '',
            cokeName5Filter : '',
            cokeConsumption5Filter : '',
            cokeWater5Filter : '',
            cokeDryBasis5Filter : '',
            cokeTotalConsumptionFilter : '',
            cokeTotalDryFilter : '',
            silicaConsumptionFilter : '',
            dolomiteConsumptionFilter : '',
            serpentineConsumptionFilter : '',
            heavySlagFilter : '',
            recorderIdFilter : '',
            recorderFilter : '',
            reviewerIdFilter : ''
        };
        
        const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));
        
        const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));
        
        const filterConfigs = [
                {
                key: 'recordTimeRteFilter',
                label: 'label.mintal.prd.mintalMesPrdSmeltingMaterialConsumption.filter.recordTimeRte',
                disabled: false,
                form: {
                type: 'datetimepicker'
                        }
                },
                {
                key: 'recordTimeLteFilter',
                label: 'label.mintal.prd.mintalMesPrdSmeltingMaterialConsumption.filter.recordTimeLte',
                disabled: false,
                form: {
                type: 'datetimepicker'
                        }
                },
                {
                key: 'locationNameFilter',
                label: 'label.mintal.prd.mintalMesPrdSmeltingMaterialConsumption.filter.locationName',
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,entity: 'imfMstLocation'
                    ,correspondingField: 'name'
                    ,fieldsBindingByEntityModalSelected: '{"locationId":"id"}'
                        }
                },
                {
                key: 'furnaceNameFilter',
                label: 'label.mintal.prd.mintalMesPrdSmeltingMaterialConsumption.filter.furnaceName',
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,entity: 'mintalMesMstFurnace'
                    ,correspondingField: 'furnaceName'
                    ,fieldsBindingByEntityModalSelected: '{"furnaceId":"id"}'
                        }
                },
                {
                key: 'recorderFilter',
                label: 'label.mintal.prd.mintalMesPrdSmeltingMaterialConsumption.filter.recorder',
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,entity: 'emAclUser'
                    ,correspondingField: 'name'
                    ,fieldsBindingByEntityModalSelected: '{"recorderId":"id"}'
                        }
                },
        ];
        
        
            const entityFormConfigs = [
                {
                key: 'recordTime',
                label: 'label.mintal.prd.mintalMesPrdSmeltingMaterialConsumption.entity.recordTime',
                sortable: true,
                disabled: false,
                form: {
                type: 'datetimepicker'
                        }
                },
                {
                key: 'locationName',
                label: 'label.mintal.prd.mintalMesPrdSmeltingMaterialConsumption.entity.locationName',
                sortable: true,
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,required: true
                    ,entity: 'imfMstLocation'
                    ,correspondingField: 'name'
                    ,fieldsBindingByEntityModalSelected: '{"locationId":"id"}'
                        }
                },
                {
                key: 'furnaceName',
                label: 'label.mintal.prd.mintalMesPrdSmeltingMaterialConsumption.entity.furnaceName',
                sortable: true,
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,required: true
                    ,entity: 'mintalMesMstFurnace'
                    ,correspondingField: 'furnaceName'
                    ,fieldsBindingByEntityModalSelected: '{"furnaceId":"id"}'
                        }
                },
                {
                key: 'pelletConsumption',
                label: 'label.mintal.prd.mintalMesPrdSmeltingMaterialConsumption.entity.pelletConsumption',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'pelletWater',
                label: 'label.mintal.prd.mintalMesPrdSmeltingMaterialConsumption.entity.pelletWater',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'cokeName1',
                label: 'label.mintal.prd.mintalMesPrdSmeltingMaterialConsumption.entity.cokeName1',
                sortable: true,
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'cokeConsumption1',
                label: 'label.mintal.prd.mintalMesPrdSmeltingMaterialConsumption.entity.cokeConsumption1',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'cokeWater1',
                label: 'label.mintal.prd.mintalMesPrdSmeltingMaterialConsumption.entity.cokeWater1',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'cokeName2',
                label: 'label.mintal.prd.mintalMesPrdSmeltingMaterialConsumption.entity.cokeName2',
                sortable: true,
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'cokeConsumption2',
                label: 'label.mintal.prd.mintalMesPrdSmeltingMaterialConsumption.entity.cokeConsumption2',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'cokeWater2',
                label: 'label.mintal.prd.mintalMesPrdSmeltingMaterialConsumption.entity.cokeWater2',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'cokeName3',
                label: 'label.mintal.prd.mintalMesPrdSmeltingMaterialConsumption.entity.cokeName3',
                sortable: true,
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'cokeConsumption3',
                label: 'label.mintal.prd.mintalMesPrdSmeltingMaterialConsumption.entity.cokeConsumption3',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'cokeWater3',
                label: 'label.mintal.prd.mintalMesPrdSmeltingMaterialConsumption.entity.cokeWater3',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'cokeName4',
                label: 'label.mintal.prd.mintalMesPrdSmeltingMaterialConsumption.entity.cokeName4',
                sortable: true,
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'cokeConsumption4',
                label: 'label.mintal.prd.mintalMesPrdSmeltingMaterialConsumption.entity.cokeConsumption4',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'cokeWater4',
                label: 'label.mintal.prd.mintalMesPrdSmeltingMaterialConsumption.entity.cokeWater4',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'cokeName5',
                label: 'label.mintal.prd.mintalMesPrdSmeltingMaterialConsumption.entity.cokeName5',
                sortable: true,
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'cokeConsumption5',
                label: 'label.mintal.prd.mintalMesPrdSmeltingMaterialConsumption.entity.cokeConsumption5',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'cokeWater5',
                label: 'label.mintal.prd.mintalMesPrdSmeltingMaterialConsumption.entity.cokeWater5',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'silicaConsumption',
                label: 'label.mintal.prd.mintalMesPrdSmeltingMaterialConsumption.entity.silicaConsumption',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'dolomiteConsumption',
                label: 'label.mintal.prd.mintalMesPrdSmeltingMaterialConsumption.entity.dolomiteConsumption',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'serpentineConsumption',
                label: 'label.mintal.prd.mintalMesPrdSmeltingMaterialConsumption.entity.serpentineConsumption',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'heavySlag',
                label: 'label.mintal.prd.mintalMesPrdSmeltingMaterialConsumption.entity.heavySlag',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'remark',
                label: 'label.mintal.prd.mintalMesPrdSmeltingMaterialConsumption.entity.remark',
                sortable: true,
                disabled: false,
                form: {
                type: 'textarea'
                        }
                }
        ]
        
        export {MintalMesPrdSmeltingMaterialConsumption, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
        , filterConfigs
        
        
        }
        